import apiPrd from './apiPrd'

const CentrifugeService = {
  async getToken() {
    // FIXME: PASSING AN EMPTY OBJCT
    // MORE: https://github.com/infinitered/apisauce/issues/120
    const res = await apiPrd.get('/channel/token', {}, { data: {} })
    return res.data
  },
  async getChannels() {
    const res = await apiPrd.get('/channel', {}, { data: {} })
    return res.data
  },
}

export default CentrifugeService
